import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { LicensesComponent } from './licenses/licenses.component';
import { PrimeNgModule } from '../shared/themes/primeng.module';
import { LicensesListComponent } from './licenses/licenses-list/licenses-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DirectivesModule } from '../core/directives/directive.module';
import { CoreModule } from '../core/core.module';
import { LicenseDetailComponent } from './licenses/license-detail/license-detail.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivateLicenseDialogComponent } from './licenses/activate-license-dialog/activate-license-dialog.component';
import { LicenseKeyCopyableComponent } from './licenses/license-key-copyable/license-key-copyable.component';
import { ActivationSuccessDialogComponent } from './licenses/activation-success-dialog/activation-success-dialog.component';
import { DetachedLoginComponent } from './detached-login/detached-login.component';
import { SsoDetachedLoggedInComponent } from './sso-detached-logged-in/sso-detached-logged-in.component';
import { CopyOfflineCustomerKeyDialogComponent } from './sso-detached-logged-in/copy-offline-customer-key-dialog/copy-offline-customer-key-dialog.component';

@NgModule({
  declarations: [LicensesComponent, LicensesListComponent, LicenseDetailComponent, ActivateLicenseDialogComponent, LicenseKeyCopyableComponent, ActivationSuccessDialogComponent, DetachedLoginComponent, SsoDetachedLoggedInComponent, CopyOfflineCustomerKeyDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    PrimeNgModule,
    DirectivesModule,
    ScrollingModule,
    CoreModule,
    ReactiveFormsModule,
    DirectivesModule,
    TranslateModule,
  ],
  exports: [RouterModule],
})
export class MainModule {}
